export default __webpack_public_path__ + "static/media/plus-icon.149b108c.svg";